import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-stores/store";
import { selectProCampaigns } from "../../redux-stores/selectors/campaignSelectors";
import { getCategory } from "./sponsorshipCampaignShared";
import "./style.scss";
import SponsorshipCampaignCard from "./SponsorshipCampaignCard";
import SponsorshipSectionSkeleton from "../../skeletons/SponsorshipSectionSkeleton";

const ProCampaignsSection: React.FC = () => {
    const proCampaigns = useSelector(selectProCampaigns);
    const loading = useSelector((state: RootState) => state.campaigns.loading);

    if (loading && proCampaigns.length === 0) {
        return <div className="px-3"><SponsorshipSectionSkeleton /></div>;
    }

    if (proCampaigns.length === 0) {
        return null;
    }

    return (
        <section className="sponsorship-section">
            <p className="sponsorship-section-title px-3">For the pros</p>
            <div className="sponsorship-cards-scroll px-3 py-2">
                {proCampaigns.map((campaign) => (
                    <SponsorshipCampaignCard
                        key={campaign.uuid}
                        campaign={campaign}
                        proBadge
                    />
                ))}
            </div>
        </section>
    );
};

export default ProCampaignsSection;
